import {type Channel, ChannelType} from '@mattermost/types/channels';

/**
 *
 * @deprecated используйте channel.type === ChannelType.Group
 */
export const isGroupChannel = (channel: Channel | undefined) => {
    return channel?.type === ChannelType.Group;
};
